<style lang="scss">
  .animate {
    transition: .35s;
  }

  .animate:hover {
    box-shadow: 0px 4px 25px 0px rgba(0,0,0,.25);
    transform: translateY(-5px);
  }
</style>
<template>
  <div>
    <div class="vx-col w-full">
      <vs-button :to="`/labels/detail/${uuid}`" class="w-full my-2 sm:w-auto" color="primary" type="filled">{{$t('Labels.Back')}}</vs-button>
    </div>
    <vx-card class="block w-full ">
      <div class="text-center text-3xl mb-5">{{$t('Labels.Assigned')}}</div>
      <div class="flex">
        <div class="flex-1 p-2 text-xl">
          <valueItem :description="$tc('Devices',1)" img="cpu" :value="label.alias_device"></valueItem>
          <valueItem :description="$t('Labels.Type')" img="cpu" :value="label.type"></valueItem>
        </div>
        <div class="flex-1 text-center p-2">
          <vx-card class="w-64 m-auto" v-if="label.status !== ''">
              <div class="block text-center">
                <div class="inline-block align-middle">
                    <div  class="inline-block align-middle">
                        <img class="h-12 d-theme-dark-bg" v-bind:src="getIcon(label.status)"/>
                    </div>
                    <div  class="inline-block text-xl ml-3 align-middle">{{getMessage(label.status)}}</div>
                </div>
            </div>
          </vx-card>
        </div>
      </div>
    </vx-card>
    <div class="block sm:flex mt-2">
      <vx-card class="w-full sm:flex-1 h-full text-center sm:mr-2">
        <div class="text-3xl">{{$t('Labels.Alias')}}: {{label.alias_label}}</div>
         <vx-card class="inline-flex m-2 w-auto align-middle" v-if="selected">
            <div class="flex items-center text-center">
                <div class="block">
                    <img alt="" class="h-12" v-bind:src="getImgUrl(selected.device)"/>
                </div>
                <div class="block">
                    <span class="main-info ml-2">
                         {{selected.alias_device}}
                    </span>
                </div>
            </div>
          </vx-card>
          <div class="submit-button-container mt-5 text-right">
            <vs-button @click="assign()" class="submit-button" :disabled="selected == null">
              {{$t('Labels.Assign')}}
            </vs-button>
          </div>
      </vx-card>
      <vx-card class="w-full sm:mt-0 sm:flex-1 text-center">
          <div class="text-center text-3xl"> {{$t('Labels.NotAssigned')}}</div>
          <div class="mb-5 text-xl">{{$t('Labels.SelectOne')}}:</div>
          <vx-card @click="select(response.id_device, response.device)" class="inline-flex cursor-pointer m-2 w-auto align-middle animate" v-for="response in response" :key="response.id">
            <div class="flex items-center text-center">
                <div class="block">
                    <img alt="" class="h-5" v-bind:src="getImgUrl(response.device)"/>
                </div>
                <div class="block">
                    <span class="main-info ml-2" v-if="response.alias_device">
                        {{ response.alias_device }}
                    </span>
                </div>
            </div>
          </vx-card>
      </vx-card>
    </div>
  </div>
</template>
<script>
import { request } from '@/request.js'
import valueItem from '@/components/valueItem/valueItem.vue'

export default {
  name: 'dashboard',
  components: {
    valueItem
  },
  data () {
    return {
      response: [],
      selected: null,
      label: {
        device_name: 'sin alerta',
        value: [],
        status: '1'
      },
      uuid: this.$route.params.uuid
    }
  },
  methods: {
    async getDevices () {
      this.$vs.loading()

      const params = {
        url: 'modelo/labels/unassign/devices',
        method: 'GET'
      }
      await request(params).then(response => {
        this.response = response.data.data
      })
        .finally(() => {
          this.$vs.loading.close()
        })
    },
    async getLabel () {
      this.$vs.loading()
      const params = {
        url: `modelo/labels/${this.$route.params.uuid}`,
        method: 'GET'
      }
      await request(params).then(response => {
        this.label = response.data.data
        this.label.value = JSON.parse(this.label.value)
      })
        .finally(() => {
          this.$vs.loading.close()
        })
    },
    getImgUrl (name) {
      const img = {
        T: 'envtemperature',
        P: 'doors',
        E: 'energy',
        F: 'airflow',
        A: 'agro'
      }
      const images = require.context('@/assets/images/icons/', false, /\.svg$/)
      return images(`./${img[name]}.svg`)
    },
    getIcon (status) {
      status = parseInt(status) - 1
      const img = [
        'no_alert',
        'cold',
        'hot',
        'pressure_label',
        'pressure_label',
        'energy_label',
        'energy_label',
        'humidity',
        'humidity',
        'open',
        'clock_alert',
        'error'
      ]
      if (status < 0 || status > 10) { status = 11 }
      const images = require.context('@/assets/images/icons/', false, /\.svg$/)
      return images(`./${img[parseInt(status)]}.svg`)
    },
    getMessage (status) {
      status = parseInt(status) - 1
      const message = [
        'Normal',
        'Temperatura baja',
        'Temperatura alta',
        'Presion baja',
        'Presion alta',
        'Sobrecarga de energia',
        'Perdida de energia',
        'Humedad alta',
        'Humedad baja',
        'Apertura',
        'Apertura prolongada',
        'Error'
      ]
      if (status < 0 || status > 10) { status = 11 }
      return message[parseInt(status)]
    },
    select (id, type) {
      this.selected = this.response.find(function (item) {
        return item.id_device === id && item.device === type
      })
    },
    async assign () {
      this.$vs.loading()
      const params = {
        url: `modelo/labels/${this.$route.params.uuid}/assign`,
        method: 'PUT',
        params: {
          device_id: this.selected.id_device,
          device_type: this.selected.device
        }
      }
      await request(params).then(() => {
        this.getLabel()
      }).finally(() => {
        this.$vs.loading.close()
      })
    }
  },
  mounted () {
    this.getLabel()
    this.getDevices()
  }
}
</script>
